module.exports = __webpack_public_path__ + "img/inactive_instance.3a4dbd20.png";